import { render, staticRenderFns } from "./inasistencias.vue?vue&type=template&id=9372e7d6&scoped=true&"
import script from "./inasistencias.vue?vue&type=script&lang=js&"
export * from "./inasistencias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9372e7d6",
  null
  
)

export default component.exports